export function shortenString(str) {
    return str.substring(0, 6) + '...' + str.substring(str.length - 4);
}
//# sourceMappingURL=common.js.map